module.exports = __webpack_public_path__ + "static/media/gitbook.fdacc12c.svg";